import { render, staticRenderFns } from "./software-evalution.vue?vue&type=template&id=721f852a&scoped=true&"
import script from "./software-evalution.vue?vue&type=script&lang=js&"
export * from "./software-evalution.vue?vue&type=script&lang=js&"
import style0 from "./software-evalution.vue?vue&type=style&index=0&id=721f852a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721f852a",
  null
  
)

export default component.exports